const feedbackForm = document.getElementById("ratingForm");

if (feedbackForm) {
  feedbackForm.onsubmit = function (e) {
    e.preventDefault();

    // Fetch values for pharmacy rating and experience rating
    const pharmacyRating =
      document.querySelector('input[name="rating"]:checked')?.value ||
      "No rating";
    const experienceRating =
      document.querySelector('input[name="rating_experience"]:checked')
        ?.value || "No rating";

    showThankyou(pharmacyRating, experienceRating);
  };

  function showThankyou(pharmacyVal, experienceVal) {
    const pharmacyText = pharmacyVal > 1 ? "stars" : "star";
    const experienceText = experienceVal > 1 ? "stars" : "star";
    const panel = document.querySelector(".card-box-wrap");

    panel.innerHTML = `
      <h1>Thank you!</h1>
      <br>
      <strong>Pharmacy Feedback: ${pharmacyVal} ${pharmacyText}</strong>
      <br>
      <strong>Experience Feedback: ${experienceVal} ${experienceText}</strong>
      <p>We'll use your feedback to improve our support.</p>
    `;
  }

  function handleChange() {
    // Enable the submit button when any rating is selected
    const inputRatings = document.querySelectorAll('input[type="radio"]');
    const submitBtn = document.querySelector('button[type="submit"]');
    submitBtn.disabled = true; // Initially disabled

    inputRatings.forEach((input) => {
      input.addEventListener("change", () => {
        // Enable the submit button if at least one rating is selected in any fieldset
        const isPharmacyRated = document.querySelector(
          'input[name="rating"]:checked'
        );
        const isExperienceRated = document.querySelector(
          'input[name="rating_experience"]:checked'
        );
        submitBtn.disabled = !(isPharmacyRated || isExperienceRated);
      });
    });
  }
  handleChange();
}
